<template>
    <div class="register-manage">
        <div class="register-manage-content">
            <div class="left-tabs">
                <el-tabs v-model="activeName" @tab-click="handleTabClick">
                    <el-tab-pane
                        v-for="item in registerTabs"
                        :key="item.name"
                        :label="item.label"
                        :name="item.name"
                    ></el-tab-pane>
                </el-tabs>
            </div>
            <div class="register-main-content">
                <router-view :key="$route.fullPath"></router-view>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "Register",
  data() {
    return {
        activeName: "sealRegister",
        registerTabs: [{
            label: "电子印章注册",
            name: "sealRegister"
        },{
            label: "资料修改",
            name: "infoModify"
        },{
            label: "合同用印操作",
            name: "sealOperation"
        }]
    };
  },
  methods:{
    handleTabClick(tab){
        this.$router.push({
            name: tab.name
        })
    }
  },
  mounted(){
        this.activeName = this.$route.name;
        if(this.$route.name=="modifyRecord" || this.$route.name=="doModify"){
            this.activeName = "infoModify"
        }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/register/index.vue